export const MANAGER_HISTORY_ENTITY_TYPES = {
  CLUSTER: 'cluster',
  BUSINESS_UNIT: 'businessUnit',
  PROJECT: 'project',
  TEAM: 'team',
};

// API type values for POST endpoint
export const MANAGER_HISTORY_API_TYPES = {
  [MANAGER_HISTORY_ENTITY_TYPES.CLUSTER]: 'cluster',
  [MANAGER_HISTORY_ENTITY_TYPES.BUSINESS_UNIT]: 'business_unit',
  [MANAGER_HISTORY_ENTITY_TYPES.PROJECT]: 'project',
  [MANAGER_HISTORY_ENTITY_TYPES.TEAM]: 'team',
};

// Get the entity ID field name for the API request
export const getEntityIdField = (entityType) => {
  switch (entityType) {
    case MANAGER_HISTORY_ENTITY_TYPES.CLUSTER: return 'clusterId';
    case MANAGER_HISTORY_ENTITY_TYPES.BUSINESS_UNIT: return 'businessUnitId';
    case MANAGER_HISTORY_ENTITY_TYPES.PROJECT: return 'projectId';
    case MANAGER_HISTORY_ENTITY_TYPES.TEAM: return 'teamId';
    default: return null;
  }
};

export const getManagerHistoryTerminology = (entityType) => {
  return entityType === MANAGER_HISTORY_ENTITY_TYPES.BUSINESS_UNIT ? 'owner' : 'manager';
};

// Manager of Record source types
export const MOR_SOURCE_TYPES = {
  PROJECT: 'project',
  ORG_UNIT: 'org_unit',
  BENCH_LAST_PROJECT: 'bench_last_project',
  OVERRIDE: 'override',
};

export const MOR_SOURCE_LABELS = {
  [MOR_SOURCE_TYPES.PROJECT]: 'Project',
  [MOR_SOURCE_TYPES.ORG_UNIT]: 'Org Unit',
  [MOR_SOURCE_TYPES.BENCH_LAST_PROJECT]: 'Bench (Last Project)',
  [MOR_SOURCE_TYPES.OVERRIDE]: 'Override',
};

export const MOR_SOURCE_COLORS = {
  [MOR_SOURCE_TYPES.PROJECT]: '#3B82F6',
  [MOR_SOURCE_TYPES.ORG_UNIT]: '#8B5CF6',
  [MOR_SOURCE_TYPES.BENCH_LAST_PROJECT]: '#F59E0B',
  [MOR_SOURCE_TYPES.OVERRIDE]: '#EF4444',
};

export const getEntityTypeName = (type) => {
  const names = {
    project: 'Project',
    team: 'Team',
    business_unit: 'Business Unit',
    cluster: 'Cluster'
  };
  return names[type] || type;
};

export const getEntityTypeColors = (type) => {
  const colors = {
    project: { bg: '#E3F2FD', text: '#1565C0' },
    team: { bg: '#F3E5F5', text: '#7B1FA2' },
    business_unit: { bg: '#FFF3E0', text: '#E65100' },
    cluster: { bg: '#E8F5E9', text: '#2E7D32' }
  };
  return colors[type] || { bg: '#F5F5F5', text: '#616161' };
};

export const getEntityRoleName = (type) => {
  const roles = {
    team: 'Team Manager',
    project: 'Project Manager',
    business_unit: 'Business Unit Owner',
    cluster: 'Cluster Manager'
  };
  return roles[type] || '';
};
